import { motion } from "framer-motion";
import BeforeAfterSlider from "@/components/site/BeforeAfterSlider";

export default function BeforeAfter() {
  return (
    <section
      id="vorher-nachher"
      data-testid="before-after-section"
      className="bg-yx-surface py-24 sm:py-32"
    >
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.28em] text-yx-secondary mb-4">
              Vorher · Nachher
            </p>
            <h2 className="font-display font-bold tracking-tighter text-yx-primary text-4xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-2xl">
              Der Unterschied,
              <br />
              den Sorgfalt macht.
            </h2>
          </div>
          <p className="max-w-sm text-yx-muted leading-relaxed">
            Ziehen Sie den Regler nach links oder rechts, um Vorher und Nachher direkt zu vergleichen.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6"
        >
          <BeforeAfterSlider
            beforeSrc="/hedge-before.webp"
            afterSrc="/hedge-after.webp"
            beforeLabel="Vorher"
            afterLabel="Nachher"
          />
          <BeforeAfterSlider
            beforeSrc="/hedge-before-2.webp"
            afterSrc="/hedge-after-2.webp"
            beforeLabel="Vorher"
            afterLabel="Nachher"
          />
        </motion.div>
      </div>
    </section>
  );
}
